import {
    ActivityHospitalTimelineEntry,
    HospitalMessageHospitalTimelineEntry,
    HospitalTimelineEntry
} from "@/hospital/interfaces/hospital-timeline";
import {Activity, MessagesSquare} from "@lucide/vue";
import {FunctionalComponent} from "vue";
import {useSystemStore} from "@/stores/system.store";

export interface TimelineEntryConfig {
    icon: FunctionalComponent
}

/**
 * Service to hospital timeline entries.
 */
const HospitalTimelineService = () => {
    return {
        /**
         * Get the configuration for a timeline entry based on its type.
         */
        entryConfig: (entry: HospitalTimelineEntry): TimelineEntryConfig => {
            switch (entry.entryable_type) {
                case 'hospital-message':
                    return {
                        icon: MessagesSquare,
                    };
                case 'activity':
                    return {
                        icon: Activity,
                    };
            }
        },

        /**
         * Type guard to check if the entry is a hospital message.
         */
        isHospitalMessage: (entry: HospitalTimelineEntry): entry is HospitalMessageHospitalTimelineEntry => {
            return entry.entryable_type === 'hospital-message';
        },

        /**
         * Type guard to check if the entry is an activity.
         */
        isActivity: (entry: HospitalTimelineEntry): entry is ActivityHospitalTimelineEntry => {
            return entry.entryable_type === 'activity';
        },

        /**
         * Determine if the entry is from the current environment.
         * @param entry
         */
        isFromCurrentEnvironment: function (entry: HospitalTimelineEntry): boolean {
            const {environment} = useSystemStore();

            if (this.isActivity(entry)) {
                return entry.entryable.organization_id === (environment?.organizationId ?? false);
            }

            if (this.isHospitalMessage(entry)) {
                return entry.entryable.sender_type === 'user_access_point'
                    && entry.entryable.sender_id === (environment?.id ?? false);
            }

            return false;
        }
    };
};

export default HospitalTimelineService();
